import React from 'react';

import classNames from 'classnames';

import styles from './Close.module.css';

export enum CloseThickness {
  Bold = '3',
  Thin = '2',
}

export enum CloseType {
  Cross = 'cross',
  Plus = 'plus',
}

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(evt?: React.SyntheticEvent): void;
  thickness?: CloseThickness;
  type?: CloseType;
  width?: number;
};

export const Close = React.memo((props: Props) => {
  const {
    width = 24,
    height = 24,
    className,
    color = '#0F0A1B',
    thickness = CloseThickness.Bold,
    type = CloseType.Cross,
    onClick,
  } = props;

  return (
    <svg
      width={width}
      height={height}
      className={classNames(type === CloseType.Plus ? styles.plus : undefined, className)}
      onClick={onClick}
      viewBox='0 0 16 16'
    >
      <path
        d='M12 12L4 4'
        stroke={color}
        strokeWidth={thickness}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4 12L12 4'
        stroke={color}
        strokeWidth={thickness}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});
